import { render } from "./ui-group-validator.vue?vue&type=template&id=5e73ebe4&ts=true"
import script from "./ui-group-validator.vue?vue&type=script&lang=ts"
export * from "./ui-group-validator.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__